import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';

import { SuperAdminSessionService } from '@services/super-admin-session.service';
import { SUPER_ADMIN_ROUTE } from '@shared/enum/common.enum';

/** Super Admin pages: requires a Super Admin session; tenant login state is irrelevant. */
export const superAdminGuard: CanActivateFn = () => {
    const session = inject(SuperAdminSessionService);
    const router = inject(Router);

    if (session.isAuthenticated()) {
        return true;
    }
    session.clear();
    return router.createUrlTree([SUPER_ADMIN_ROUTE.LOGIN]);
};

/** Login page: an active Super Admin session skips straight to the console. */
export const superAdminLoginGuard: CanActivateFn = () => {
    const session = inject(SuperAdminSessionService);
    const router = inject(Router);

    return session.isAuthenticated() ? router.createUrlTree([SUPER_ADMIN_ROUTE.ROOT]) : true;
};
